import { observable, action, toJS } from 'mobx';
import { message } from 'antd';
import { specifyApp, specifyList } from '../../api/list';
import util from '../../util/index';
import base from '../../tool/base';
const {
  catchApiError,
  getAccessToken,
} = util;
const initState = {
  loadingE9: false,
  loadingE8: false,
  themeList: [],
  themeListE8: [],
  pageE9: {
    pageNum: 1,
    pageSize: 12,
  },
  pageE8: {
    pageNum: 1,
    pageSize: 12,
  },
  countE9: 0,
  countE8: 0,
  params: {
    module: '8f16dc55-7b76-4786-97a8-8b9ecd0da935',
    type: 3,
    offset: 0,
    topN: 0,
    ind: '',
    collect: '',
    count: 0,
    apptype: '',
  },
  orderby: 'createdate',
  thumbsupAddLoading: false,
};

export class ThemeListStore {

  routing = null;
  params = initState.params;

  @observable loadingE8 = initState.loadingE8;
  @observable loadingE9 = initState.loadingE9;
  @observable themeList = initState.themeList;
  @observable themeListE8 = initState.themeListE8;
  @observable pageE9 = initState.pageE9;
  @observable pageE8 = initState.pageE8;
  @observable countE9 = initState.countE9;
  @observable countE8 = initState.countE8;
  @observable orderby = initState.orderby;
  @observable thumbsupAddLoading = initState.thumbsupAddLoading;

  constructor(routing) {
    this.routing = routing;
  }

  @action
  setState = (params = {}) => {
    Object.keys(params).forEach(key => {
      this[key] = params[key];
    });
    return this;
  }

  @action
  initPage = () => {
    this.pageE9 = initState.pageE9;
    this.pageE8 = initState.pageE8;
  }

  @action
  clear = () => this.setState(initState)

  @action
  getThemeList = async (params, loading = true) => {
    this.loadingE9 = loading;
    params = params || {};
    const _params = {
      ...this.pageE9,
      ...params,
    }
    const res = await specifyList({
      orderby: this.orderby,
      ..._params,
      access_token: getAccessToken(),
      demotype: 'portalTheme'
    });
    try {
      if (res.status) {
        this.themeList = res.demoList;
        this.countE9 = res.count;
      } else {
        console.log('后端接口异常，请联系管理员！');
      }
    } catch (e) {
      console.log('接口错误：', e);
    }
    this.loadingE9 = false;
  }

  @action
  getThemeE8List = async params => {
    this.loadingE8 = true;
    const _params = {
      ...this.params,
      ...this.pageE8,
      current: this.pageE8.pageNum,
      ...params,
    }
    const res = await specifyApp({
      ..._params,
      access_token: getAccessToken(),
      moduleType: 'portalTheme'
    });
    try {
      if (res.status === 'true') {
        this.themeListE8 = res.apps;
        this.countE8 = res.count;
      } else {
        console.log('后端接口异常，请联系管理员！');
      }
    } catch (e) {
      console.log('接口错误：', e);
    }
    this.loadingE8 = false;
  }

  @action
  callCollect = (params = {}) => {
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise(resolve => {
      base.callApi(`/v1/appcollect/${params.s_ids}/edit`, 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => { 
        if (data.status === 'true') {
          message.success(params.collect === '0' ? '收藏成功' : '取消成功');
        } else {
          message.success(data.msg ? data.msg : params.collect === '0' ? '收藏失败，请重试！' : '取消失败，请重试！');
        }
        resolve(data);
      });
    });
  }

  @action
  thumbsupAdd = (params = {}) => {
    this.thumbsupAddLoading = true;
    const param = {
      ...params,
      access_token: getAccessToken(),
    };
    return new Promise((resolve, reject) => {
      base.callApi(`/v5/ecode/thumbsupAdd`, 'POST', param, 'json', 'text').then((data) => catchApiError(data, this.routing)).then((data) => { 
        if (data.code != 113) {
          if (data.status) {
            // message.success(data.msg);
          } else {
            console.error(data.msg);
          }
          resolve(data);
        } else {
          reject(data);
        }
        this.thumbsupAddLoading = false
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/stores/home/ThemeListStore.js